<template>
  <iframe data-test-id="base-youtube" :src title="Youtube video" />
</template>

<script lang="ts" setup>
const { id, autoplay, controls, loop, muted, captions } = defineProps<{
  id: string
  autoplay?: boolean
  controls?: boolean
  loop?: boolean
  muted?: boolean
  captions?: boolean
}>()

const src = computed(() => {
  const url = new URL(`https://www.youtube.com/embed/${id}`)

  if (autoplay) url.searchParams.set('autoplay', '1')
  if (autoplay || muted) url.searchParams.set('mute', '1')
  if (loop) url.searchParams.set('loop', `1&playlist=${id}`)
  if (!controls) url.searchParams.set('controls', '0')
  if (captions) url.searchParams.set('cc_load_policy', '1')

  return url.toString()
})
</script>
